import { filterNan, roundNumber } from '../../model'
import s from './styles.module.scss'
import cn from 'clsx'

export const InputHint = ({
  distance,
  distancePerCent,
  amount,
  level,
  walletSymbol,
  activeField,
  amountFieldName = 'Loss',
  wrap = true,
}: {
  distance: number | null
  distancePerCent: number | null
  amount: number | null
  level: number | null
  walletSymbol: string
  activeField?: 'amount' | 'distance' | 'level'
  amountFieldName?: 'Loss' | 'Profit'
  wrap?: boolean
}) => {
  return (
    <>
      {activeField === 'amount' && (
        <div className={cn(s.otherValues, wrap && s.wrap)}>
          <span className={s.left}>
            Distance:
            <span className={s.value}>
              {filterNan(distance)}{' '}
              <span className={s.percent}>({roundNumber(filterNan(distancePerCent) ?? 0 * 100, 3)}%)</span>
            </span>
          </span>
          <span className={s.right}>
            Level: <span className={s.value}>{filterNan(level)}</span>
          </span>
        </div>
      )}
      {activeField === 'distance' && (
        <div className={cn(s.otherValues, wrap && s.wrap)}>
          <span className={s.left}>
            {amountFieldName}:{' '}
            <span className={s.value}>
              {walletSymbol}
              {filterNan(amount)}
            </span>
          </span>
          <span className={s.valueLevel}>
            Level: <span className={s.right}>{filterNan(level)}</span>
          </span>
        </div>
      )}
      {activeField === 'level' && (
        <div className={cn(s.otherValues, wrap && s.wrap)}>
          <span className={s.right}>
            {amountFieldName}:{' '}
            <span className={s.value}>
              {walletSymbol}
              {filterNan(amount)}
            </span>
          </span>
          <span className={s.left}>
            Distance: <span className={s.value}>{filterNan(distance)}</span>
          </span>
        </div>
      )}
    </>
  )
}
